import React from 'react';

const EditProfile = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold text-gray-900">Edit Profile</h1>
      <p className="mt-4 text-gray-600">Edit profile page component (placeholder)</p>
    </div>
  );
};

export default EditProfile;
